import request from '@/utils/request'; // 列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFoundType/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFoundType/add',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFoundType/update',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFoundType/detail',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/goodsLostAndFoundType/delete',
    method: 'post',
    data: data
  });
}